import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ApplicationService } from "../services";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard {
  applicationService = inject(ApplicationService);
  router = inject(Router);
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.applicationService.restoreAccessToken();
    if (this.applicationService.isAdmin()) {
      return true;
    }
    const result: UrlTree = this.router.parseUrl('/login');
    result.queryParams = { returnUrl: state.url };
    return result;
  }
}
